import { styled } from '@mui/material/styles';

export const TabPanelStyled = styled('div')({
  width: 'inherit',
  height: 'inherit',
});
